import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import { Operator } from "../models/Operator";

export const getOperators = async (signal?: AbortSignal) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [];

	const resp = await apiService.callV2(
		"[M2].[GetOperators]",
		parameters,
		signal,
	);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as Operator[];
	} else {
		throw new Error(resp.message || "Error fetching operators");
	}
};
